import {Component, Input, OnInit} from '@angular/core';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {CoreService} from '@app/services/core.service';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';

@Component({
  selector: 'app-sticker-button',
  templateUrl: './sticker-button.component.html',
  styleUrls: ['./sticker-button.component.css']
})
export class StickerButtonComponent implements OnInit {
  @Input() userListView: boolean;
  @Input() remoteUser: RemoteParticipantInfo;
  @Input() userIndex: number;
  @Input() studentsCount: number;

  public classroom: ClassroomStateModel;

  public status = {isOpenStarButtonVideoList: false};

  constructor(
    private store: Store,
    private coreService: CoreService
  ) {}

  public ngOnInit(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }

  public addSticker(sticker): void {
    this.coreService.sendAddSticker(sticker, this.remoteUser.id).subscribe();
  }
}
